import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import localizationConfig from '../configs/LocalizationConfig';

const resources = {
	en: {
		translation: localizationConfig.en,
	},
	fr: {
		translation: localizationConfig.fr,
	},
};

i18n.use(LanguageDetector).use(initReactI18next).init({
	resources,
	interpolation: {
		escapeValue: false,
	},
	keySeparator: false,
	nsSeparator: false,
	fallbackLng: false,
	saveMissing: true,
	ns: [],
	missingKeyHandler: (lngs, ns, key, fallbackValue) => {
		console.log(`Missing translation for key "${key}" for language "${lngs}", falling back to "${fallbackValue}"`);

		if (lngs[0] === 'en' || lngs[0] === 'en-US') {
			const stringToShow = key.replace(new RegExp('"', 'g'), '\\"');
			console.log(`Add this to the English translation file: "${stringToShow}": "${stringToShow}",`);
		}
	},
});

export default i18n;
